import { Controller } from "@hotwired/stimulus";

/**
 * turbo_stream の応答から、flash-toast 経由でトーストメッセージを表示する。
 * #flash を直接更新すると、モーダルのドロワーが開いている間はトーストが隠れるため、
 * ドロワー内への追加に対応した flash-toast の show を呼び出す。
 * @example
 * <span data-controller="toast-trigger" data-toast-trigger-message-value="メッセージ"></span>
 */
export default class extends Controller {
  static values = { message: String };

  connect() {
    const flash = document.getElementById("flash");
    const toast = flash && this.application.getControllerForElementAndIdentifier(flash, "flash-toast");
    if (toast && this.messageValue) toast.show(this.messageValue);
    // 表示後は不要になるため取り除く
    this.element.remove();
  }
}
